import React from 'react';
import { ChatChannelsListComponent } from 'app/components/Chat/ChatChannelsList/ChatChannelsListComponent';
import { useFetchChannelsList } from 'app/components/Chat/ChatChannelsList/hooks';

export const ChatChannelsList = () => {
  const { channels, loading } = useFetchChannelsList();

  return <ChatChannelsListComponent loading={loading} channels={channels} />;
};
